function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "rename",
  fill: "#000000",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0.1,13.9 C0,14 0,14.2 0,14.4 C0.3,15.6 2.3,16.5 4.7,16.5 C7.1,16.5 9.1,15.6 9.4,14.4 C9.4,14.2 9.4,14 9.3,13.9 L5.6,5.6 C5.2,4.8 4.1,4.8 3.8,5.6 L0.1,13.9 Z M6.6,14.1 L2.8,14.1 C2.1,14.1 1.6,13.4 1.9,12.7 L3.8,8.5 C4.2,7.7 5.3,7.7 5.6,8.5 L7.5,12.7 C7.8,13.4 7.3,14.1 6.6,14.1 Z M17.9,5.6 L14.2,13.9 C14.1,14.1 14.1,14.2 14.1,14.4 C14.4,15.6 16.4,16.5 18.8,16.5 C21.2,16.5 23.2,15.6 23.5,14.4 C23.5,14.2 23.5,14 23.4,13.9 L19.7,5.6 C19.4,4.8 18.2,4.8 17.9,5.6 Z M20.7,14.1 L16.9,14.1 C16.2,14.1 15.7,13.4 16,12.7 L17.9,8.5 C18.3,7.7 19.4,7.7 19.7,8.5 L21.6,12.7 C21.9,13.4 21.4,14.1 20.7,14.1 Z M15.3,20 L15.3,18.8 L13.9,18.8 C13.3,18.8 12.9,18.4 12.9,17.8 L12.9,5.7 C12.9,5.1 12.5,4.7 11.9,4.7 L11.5,4.7 C10.9,4.7 10.5,5.1 10.5,5.7 L10.5,17.8 C10.5,18.4 10.1,18.8 9.5,18.8 L8.2,18.8 L8.2,20 L4.7,20 L4.7,21.2 L18.8,21.2 L18.8,20 L15.3,20 Z M15.3,2.4 L15.3,1.2 L12.9,1.2 L12.9,-5.68434189e-14 L10.6,-5.68434189e-14 L10.6,1.2 L8.2,1.2 L8.2,2.4 L2.3,2.4 L2.3,3.5 L21.1,3.5 L21.1,2.4 L15.3,2.4 Z",
  id: "contracts-svg-icon"
})));

function SvgContracts(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "22px",
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Contracts") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContracts);
export default __webpack_public_path__ + "static/media/contracts.1a9b1c5e.svg";
export { ForwardRef as ReactComponent };